// extracted by mini-css-extract-plugin
export default {"elections":"Elections_elections__lz4Yq","table":"Elections_table__kYNRT","head":"Elections_head__Z+f91"};